import { Emoji } from 'shared/entities/emoji';

export const convertEmoji = (emoji: Emoji): string => {
  const sym = emoji.unified.split('-');
  const codesArray: number[] = [];
  sym.forEach((el) => codesArray.push(Number('0x' + el)));
  return String.fromCodePoint(...codesArray);
};
